import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'

import { useSnackbar } from '../../../../components/stories/molecules/snackbar/component/snackbar-hook'
import { snackbarVariantOptions } from '../../../../components/stories/molecules/snackbar/constants'

import MoveItemsModal from '../../../../components/move-items-modal'
import {
  excludeOptions,
  useGetProjectFolderDetailsQuery
} from '../../../../react-query/project/query/use-get-project-folder-details-query'
import { useMoveProjectsAndFoldersMutation } from '../../../../react-query/project/mutation/use-move-projects-and-folders-mutation'
import { projectMenuApiErrorCodeOptions } from '../../constants'
import { getOrganizationName } from '../../../../react-query/authentication/query/use-me-query'
import { useProjectMenuListViewControl } from '../../../../hooks/use-project-menu-list-view-control'

const MoveFoldertModal = () => {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const { addSnackbar } = useSnackbar()

  const { viewType, tab } = useProjectMenuListViewControl()

  const { folderId } = useParams()
  const [moveItemsError, setMoveItemsError] = useState(null)
  const [destinationFolderHint, setDestinationFolderHint] = useState(null)

  const companyName = getOrganizationName()

  const showSnackbarSuccess = () => {
    addSnackbar({
      message: formatMessage({ id: 'moveItems_folder_moved' }),
      snackbarType: snackbarVariantOptions.SUCCESS,
      hideCloseButton: true
    })
  }

  // Queries
  const { data: folderDetails, isLoading: folderDetailsLoading } =
    useGetProjectFolderDetailsQuery(folderId, [excludeOptions.PROJECTS], {
      enabled: !!folderId
    })

  const { data: parentFolderDetails, isLoading: parentFolderDetailsLoading } =
    useGetProjectFolderDetailsQuery(
      folderDetails?.parentId,
      [excludeOptions.PROJECTS],
      {
        enabled: !!folderDetails?.parentId
      }
    )

  // Mutations
  const { mutate: moveItems, isPending: moveItemsLoading } =
    useMoveProjectsAndFoldersMutation({
      onSuccess: handleMoveProjectSuccess,
      onError: handleMoveProjectError
    })

  // handlers
  const handleOnClose = () => {
    history.push(`/project?view=${viewType}&tab=${tab}`)
  }

  function handleMoveProjectError(error) {
    // user doesn't have permission to move items
    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.NO_PERMISSION_TO_CREATE_PROJECT_OR_FOLDER
    ) {
      return setMoveItemsError(
        formatMessage({
          id: 'projectMenu_no_permission_to_move'
        })
      )
    }

    // folder with the same name already exists in the destination folder
    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.FOLDER_NAME_IS_NOT_AVAILABLE
    ) {
      return setDestinationFolderHint(
        formatMessage({
          id: 'projectMenu_folder_with_this_name_aready_exists'
        })
      )
    }

    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.FOLDER_NO_LOGER_EXISTS
    ) {
      return setDestinationFolderHint(
        formatMessage({
          id: 'recursiveFolderList_the_selected_folder_no_longer_exists'
        })
      )
    }

    return setMoveItemsError(
      formatMessage({
        id: 'moveItems_move_error'
      })
    )
  }

  function handleMoveProjectSuccess() {
    handleOnClose()
    showSnackbarSuccess()
  }

  const handleMoveItems = ({ parentFolderId }) => {
    setDestinationFolderHint(null)
    setMoveItemsError(null)
    moveItems({
      folderIds: [folderId],
      destinationFolderId: parentFolderId
    })
  }

  const isLoading = folderDetailsLoading || parentFolderDetailsLoading
  const modalTitle = formatMessage({ id: 'projects_moveFolder' })

  const getOldFolderName = () => {
    if (
      parentFolderDetails?.name === companyName ||
      !parentFolderDetails?.name
    ) {
      return formatMessage({ id: 'main_folder' })
    }

    return parentFolderDetails?.name
  }

  const oldFolderName = getOldFolderName()

  return (
    <MoveItemsModal
      handleClose={handleOnClose}
      handleMove={handleMoveItems}
      isLoading={isLoading}
      onMoveLoading={moveItemsLoading}
      onMoveError={moveItemsError}
      destinationFolderHint={destinationFolderHint}
      modalTitle={modalTitle}
      entityName={folderDetails?.name}
      oldFolderName={oldFolderName}
      isMultipleItems={false}
    />
  )
}

export default MoveFoldertModal
